import { render, staticRenderFns } from "./TraceabilityWrapperMap.vue?vue&type=template&id=48cbc0c0&scoped=true"
import script from "./TraceabilityWrapperMap.vue?vue&type=script&lang=js"
export * from "./TraceabilityWrapperMap.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityWrapperMap.vue?vue&type=style&index=0&id=48cbc0c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cbc0c0",
  null
  
)

export default component.exports